// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"17ec9132","231":"42fc69ca","537":"08e52333","952":"7cd16415"}[chunkId] + ".css";
};